export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_materialAbnormalNo') || '异常联络单号',
    field: 'materialAbnormalNo',
    minWidth: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员',
    field: 'salesPersonName',
    minWidth: 144,
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_status') || '单据状态',
    field: 'materialAbnormalStatus',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('table_label_expected_date') || '预计处理日期',
    field: 'expectedDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_processingStatus') || '业务实际处理状态',
    field: 'processingStatus',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'processingStatus'
    }
  },
  {
    title: that.$l('table_label_confirmStatus') || '财务处理状态',
    field: 'confirmStatus',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'confirmStatus'
    }
  },
  {
    title: that.$l('table_label_abnormal_procurement') || '超采原因',
    field: 'v_abnormalProcurement',
    width: 100,
    headerAlign: 'center',
    align: 'center',
  },

  {
    title: that.$l('INDEX.table_label_currencyAmount') || '费用合计',
    field: 'v_currencyAmount',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'showAmount'
    }
  },
  {
    title: that.$l('table_label_costParty') || '费用承担方',
    field: 'v_costParty',
    width: 150,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_scmName') || '承担方公司',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_costPartyAmount') || '承担金额',
    field: 'v_costPartyAmount',
    width: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_deductionMethod') || '费用处理方式',
    field: 'v_deductionMethod',
    width: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    slots: { default: 'createByName' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    slots: { default: 'modifyByName' }
  }
]
